/**
 * SEO Configuration - Centralized page title, meta description, and keywords management
 * 
 * Each route's SEO config includes:
 * - title: Page title displayed in browser tab and search results
 * - description: Meta description for search engine snippets
 * - keywords: Meta keywords for search engines
 * 
 * Usage: This config is consumed by ScrollToTop.jsx to dynamically update SEO meta tags on route change.
 * To modify any page's SEO, just edit this file.
 */

const SEO_CONFIG = [
  // ============ Home ============
  {
    path: "/home",
    title: "Singapore Warrants|Trading Stocks and Index Warrants",
    description: "See today's top traded index and single stock structured warrants in Singapore Warrants. Trading tools and stock market updates, all in one place.",
    keywords: "Singapore warrants, structured warrants, Macquarie",
    canonical: "https://warrants.com.sg/home"
  },

  // ============ Tools ============
  {
    path: "/tools/livematrix",
    title: "Live Matrix",
    description: "The live matrix consists of a table showing a range of prices for the underlying’s bid/offer and warrant’s bid/offer",
    keywords: "live matrix, live pricing, bid price",
    canonical: "https://warrants.com.sg/tools/livematrix"
  },
  {
    path: "/tools/selector",
    title: "Warrant Selector",
    description: "Use the Warrant Selector to view the current trending warrant",
    keywords: "warrant selector, investment criteria, Singapore warrants",
    canonical: "https://warrants.com.sg/tools/selector"
  },
  {
    path: "/tools/warrantsearch",
    title: "Warrant Search",
    description: "Find warrants according to your investment criteria",
    keywords: "warrant search, investment criteria, Singapore warrants",
    canonical: "https://warrants.com.sg/tools/warrantsearch"
  },
  {
    path: "/education/whymacquarie",
    title: "Why Macquarie",
    description: "Macquarie is the leading warrant issuer in Asia, and the only issuer active in 4 warrant markets in the region.",
    keywords: "structured warrants, Singapore warrants, Macquarie",
    canonical: "https://warrants.com.sg/education/whymacquarie"
  },
  {
    path: "/education/faq",
    title: "FAQ",
    description: "Learn more about warrants via the Frequently Asked Questions.",
    keywords: "call warrants, structured warrants, warrants FAQ",
    canonical: "https://warrants.com.sg/education/faq"
  },
  {
    path: "/tools/warrantterms",
    title: "Warrant Terms | Singapore Warrants | Macquarie",
    description: "Everything you need to know about your selected warrant is found here.",
    keywords: "warrant terms, Macquarie, Singapore warrants"
  },
  {
    path: "/tools/HistoricalPerformance",
    title: "Historical Performance | Singapore Warrants | Macquarie",
    description: "See the historical performance for individual warrants.",
    keywords: "historical performance, warrant returns, Singapore warrants"
  },
  {
    path: "/tools/exposuresimulator",
    title: "Exposure Simulator | Singapore Warrants | Macquarie",
    description: "A tool to help you estimate your warrant investment amount either to replicate an equivalent level of exposure to a stock or to hedge your current stockholding.",
    keywords: "exposure simulator, warrant exposure, Singapore warrants"
  },
  {
    path: "/tools/warrantcalculator",
    title: "Warrant Calculator | Singapore Warrants | Macquarie",
    description: "Estimates the theoretical price of a warrant based on your input of the underlying price, date or implied volatility.",
    keywords: "warrant calculator, Macquarie, Singapore warrants"
  },
  {
    path: "/tools/underlying",
    title: "Underlying Charts | Singapore Warrants | Macquarie",
    description: "Our charts allow investors to perform technical analysis on the warrants' underlying.",
    keywords: "underlying chart, stock chart, Singapore warrants"
  },
  {
    path: "/tools/warrantcomparison",
    title: "Warrant Comparison | Singapore Warrants | Macquarie",
    description: "Compare warrants and their key factors.",
    keywords: "warrant comparison, Singapore warrants, Macquarie"
  },
  {
    path: "/tools/document",
    title: "Warrant Documents | Singapore Warrants | Macquarie",
    description: "Provide access to Macquarie's listing documents, prospectus, terms and conditions relevant for the warrants that are issued. It is advised that you review these documents before investing.",
    keywords: "listing, prospectus, term sheets"
  },

  // ============ Market News ============
  {
    path: "/marketnews/dailyhighlights",
    title: "Morning Market Buzz | Singapore Warrants | Macquarie",
    description: "Keep up to date with the latest news relating to warrant underlyings! ",
    keywords: "daily market highlights, stock market, research"
  },
  {
    path: "/marketnews/highlight",
    title: "Morning Market Buzz | Singapore Warrants | Macquarie",
    description: "Keep up to date with the latest news and more.",
    keywords: "daily market highlights, stock market, research"
  },
  {
    path: "/marketnews/overnightmarkets",
    title: "Overnight Market Wrap | Singapore Warrants | Macquarie",
    description: "Hear about the latest news in Global markets that might affect your trading day.",
    keywords: "S&P 500 Index, US stocks, global markets"
  },
  {
    path: "/marketnews/subscribe",
    title: "Subscribe | Singapore Warrants | Macquarie",
    description: "Sign up and join over 5,000 subscribers in receiving free Morning Market Buzz.You will get the inside scoop on what's happening in the warrant market everyday.",
    keywords: "newsletter, Singapore warrants, subscribe"
  },
  {
    path: "/marketnews/photogallery",
    title: "Photo Gallery | Singapore Warrants | Macquarie",
    description: "Visit our gallery to see all of the happenings at our recent events.",
    keywords: "Photos, Macquarie, Singapore warrants"
  },
  {
    path: "/marketnews/individualgallery",
    title: "Photo Gallery | Singapore Warrants | Macquarie",
    description: "Visit our gallery to see all of the happenings at our recent events.",
    keywords: "Photos, Macquarie, Singapore warrants"
  },

  // ============ Education ============
  {
    path: "/education/getstarted",
    title: "How to Get Started | Singapore Warrants | Macquarie",
    description: "Before you start trading, the first thing you need to do isimprove your knowledge in structured warrants!",
    keywords: "how to get started, where to trade warrants, Singapore warrants"
  },
  {
    path: "/education/seminar",
    title: "Seminar | Singapore Warrants | Macquarie",
    description: "Macquarie believes that investor education is essential for trading warrants and is committed to improving the understanding of investors",
    keywords: "call warrants, seminar, Singapore warrants"
  },
  {
    path: "/education/warrantvideos",
    title: "All Videos | Singapore Warrants | Macquarie",
    description: "This section has a video playlist for Market View where you can hear from market experts about stocks/indices to watch in the short-term.",
    keywords: "warrant video, structured warrants, Macquarie"
  },
  {
    path: "/education/shortFormVideos",
    title: "Macquarie Warrants 1-minute Video Playlists | Singapore Warrants | Macquarie",
    description: "Do you have a question about structured warrants? Get your answers from these 1-minute videos.",
    keywords: "warrant video, structured warrants, Macquarie"
  },
  {
    path: "/education/marketcommentary",
    title: "Market Commentary | Singapore Warrants | Macquarie",
    description: "Gain access to Macquarie's exclusive commentary on the stock market and other relevant news, updated by 6pm each day.",
    keywords: "market insights, stock market, research"
  },
  {
    path: "/education/brochure",
    title: "Brochure | Singapore Warrants | Macquarie",
    description: "Provides a foundational overview of how structured warrants work on the SGX.",
    keywords: "warrant education, brochure, Macquarie"
  },
  {
    path: "/education/marketview",
    title: "Market View | Singapore Warrants | Macquarie",
    description: "Watch our animated series and our guest speaker videos to improve your knowledge in structured warrants now!",
    keywords: "Market View / Commentary, structured warrants, Macquarie"
  },
  {
    path: "/education/hstech",
    title: "HSTECH Warrants | Singapore Warrants | Macquarie",
    description: "Learn more about the technology focussed Hang Seng TECH Index and how to capture trading opportunities with Macquarie's HSTECH warrants!",
    keywords: "HSTECH, Hang Seng TECH Index, Index warrants"
  },
  {
    path: "/education/indexETFwarrants",
    title: "Index Warrants | Singapore Warrants | Macquarie",
    description: "What is an index warrant?",
    keywords: "index warrant, HSI warrants, S&P warrants, SiMSCI warrants"
  },
  {
    path: "/education/Indexfuturesrollover",
    title: "Index Futures Rollover | Singapore Warrants | Macquarie",
    description: "The table below lists the dates when the relevant futures contracts are expected to roll over to the following contract month.",
    keywords: "index futures, rollover, structured warrants"
  },
  {
    path: "/education/sp500",
    title: "S&P 500 Warrants | Singapore Warrants | Macquarie",
    description: "Find out how you can gain an exposure to the U.S. equity market via the S&P 500 warrants by Macquarie.",
    keywords: "index warrants, S&P warrants, structured warrants, Macquarie, SPX"
  },
  {
    path: "/education/StockWarrantPage",
    title: "Stock Warrant | Singapore Warrants | Macquarie",
    description: "What is a stock warrant?.",
    keywords: "stock warrant, single stock, Singapore warrants"
  },
  {
    path: "/SuccessSpeaks",
    title: "Success Speaks | Singapore Warrants | Macquarie",
    description: "What does it take to be a warrant trader",
    keywords: "Singapore Warrants, Success Speaks, Macquarie"
  },

  // ============ Market Data ============
  {
    path: "/marketdata/toptradedwarrants",
    title: "Top Traded Warrants | Singapore Warrants | Macquarie",
    description: "View all top traded and most active index and single stock structured warrants with highest traded volume for the day.",
    keywords: "top traded warrants, top traded volume, active warrants"
  },
  {
    path: "/marketdata/topgainloss/gainer/Today",
    title: "Top 10 Gainers / Losers  | Singapore Warrants | Macquarie",
    description: "Shows the warrants with the biggest percentage price change at the end of each day and over various periods.",
    keywords: "top gainers, top losers, price change, percentage change"
  },
  {
    path: "/marketdata/turnover",
    title: "Warrant Market Turnover | Singapore Warrants | Macquarie",
    description: "How active was the warrant market today and how did it compared to previous days.",
    keywords: "warrants market turnover, warrants turnover, Singapore warrants"
  },
  {
    path: "/marketdata/turnoverdist",
    title: "Turnover Distribution | Singapore Warrants | Macquarie",
    description: "The most popular single stock underlyings in the warrant market for the day.",
    keywords: "warrant turnover, turnover distribution, top traded underlyings"
  },

  // ============ About / Footer Pages ============
  {
    path: "/about/importantInformation",
    title: "Important Information | Singapore Warrants | Macquarie",
    description: "Read important information and risk disclosures about structured warrant trading in Singapore from Macquarie.",
    keywords: "important information, risk disclosure, Singapore warrants"
  },
  {
    path: "/about/disclaimer",
    title: "Disclaimer | Singapore Warrants | Macquarie",
    description: "Read the legal disclaimer for Macquarie Singapore Warrants website and trading tools.",
    keywords: "disclaimer, legal, Singapore warrants"
  },
  {
    path: "/about/contactus",
    title: "Contact Us | Singapore Warrants | Macquarie",
    description: "Contact the Macquarie Singapore Warrants team. Get in touch for questions about structured warrant trading.",
    keywords: "contact us, Macquarie, Singapore warrants"
  },
  {
    path: "/about/termsofuse",
    title: "Terms of Use | Singapore Warrants | Macquarie",
    description: "Read the terms of use for the Macquarie Singapore Warrants website and online trading tools.",
    keywords: "terms of use, Macquarie, Singapore warrants"
  },
  {
    path: "/about/privacypolicy",
    title: "Privacy Policy | Singapore Warrants | Macquarie",
    description: "Read Macquarie's privacy policy regarding the collection and use of personal data on the Singapore Warrants website.",
    keywords: "privacy policy, personal data, Macquarie"
  },

  // ============ Other ============
  {
    path: "/telegram",
    title: "Telegram | Singapore Warrants | Macquarie",
    description: "Welcome to Macquarie Warrants. Take your first step towards learning about structured warrants now!",
    keywords: "Singapore warrants, Telegram, Macquarie"
  },
  {
    path: "/WarrantsGuidebook",
    title: "Warrants Guidebook | Singapore Warrants | Macquarie",
    description: "Topical guidebook to understanding warrants.",
    keywords: "warrant education, call warrant, Macquarie"
  },
  {
    path: "/search",
    title: "Search | Singapore Warrants | Macquarie",
    description: "Search for warrants, market data, education content and more on the Macquarie Singapore Warrants website.",
    keywords: "search, Singapore warrants, Macquarie"
  },
  {
    path: "/Sitemap",
    title: "Sitemap | Singapore Warrants | Macquarie",
    description: "Browse the complete sitemap for the Macquarie Singapore Warrants website.",
    keywords: "sitemap, Singapore warrants, Macquarie"
  },
  {
    path: "/LandingPage",
    title: "Singapore Warrants | Macquarie",
    description: "Discover Asia's leading warrant issuer since 2005.",
    keywords: "Singapore warrants, structured warrants, Macquarie"
  },
];

// Default fallback SEO config
export const DEFAULT_SEO = {
  title: "Singapore Warrants | Trading Stocks and Index Warrants | Macquarie",
  description: "See today's top traded index and single stock structured warrants in Singapore Warrants. Trading tools and stock market updates, all in one place.",
  keywords: "Singapore warrants, structured warrants, Macquarie"
};

/**
 * Get SEO config for a given pathname
 * Supports exact match and prefix match for dynamic routes
 * @param {string} pathname - Current route pathname
 * @returns {{ title: string, description: string, keywords: string }}
 */
export function getSEOConfig(pathname) {
  // Exact match
  const exactMatch = SEO_CONFIG.find((route) => route.path === pathname);
  if (exactMatch) {
    return exactMatch;
  }

  // Prefix match for dynamic routes (e.g., /tools/livematrix/ABCD)
  // Sort by path length descending so more specific routes match first
  const sortedRoutes = [...SEO_CONFIG].sort((a, b) => b.path.length - a.path.length);
  const matchedRoute = sortedRoutes.find((route) => pathname.startsWith(route.path + "/"));

  if (matchedRoute) {
    return matchedRoute;
  }

  // Default fallback
  return DEFAULT_SEO;
}

export default SEO_CONFIG;
